export const categories = [
    { id: 1, type: "MEMORIES" },
    { id: 2, type: "CSE" },
    { id: 3, type: "IT" },
    { id: 4, type: "ECE" },
    { id: 5, type: "EE" },
    { id: 6, type: "ME" },
];